import React from 'react'

export interface ITabContext {
  activeTab: string
  addTab: (fields: { value: string; label: string; count?: number; hidden?: boolean }) => void
  updateTab: (
    tabValue: string,
    fields: { label?: string; count?: number; hidden?: boolean },
  ) => void
}
export const TabContext = React.createContext<ITabContext>({
  activeTab: null,
  addTab: (fields) => null,
  updateTab: (tabValue, fields) => null,
})

export const withTabContext = (Component: any) => (props) => {
  return (
    <TabContext.Consumer>
      {({ activeTab, addTab, updateTab }) => (
        <Component {...props} activeTab={activeTab} addTab={addTab} updateTab={updateTab} />
      )}
    </TabContext.Consumer>
  )
}
